<div style="display: flex; flex-direction: column;">
  <div style="text-align: center;font-size: 20px;font-weight: bold;">
    hola
  </div>
  <div>
    adios
  </div>
</div>